import React, { useEffect, useState } from "react";
import { Button, Typography, Input, message, Select } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { authSVC, categorySVC } from "../../services";
import { Option } from "antd/es/mentions";
import axios from "axios";
import { useB2BContext } from "../../context/ContextB2B";
import { Spin } from "antd";
import { CSVLink } from "react-csv";
import useSWR from 'swr';
import * as Cookie from "universal-cookie";
import "./DownloadCsv.scss";
// import { LazyLoadImage } from "react-lazy-load-image-component";

const cookie = new Cookie.default();
const cachedToken = cookie.get("userAuthTokenAdmin");

const { Text } = Typography;

interface Contentdata {
  _id: string;
  full_name: string;
  email: string;
  user_type: string;
  company: string;
  department: string;
}

const fetcher = (url: any) => axios.get(url, {
  headers: {
    'Authorization': `Bearer ${cachedToken}`,
    'Content-Type': 'application/json'
  }
}).then(res => res?.data?.data);
function CSVDownload() {
  // const { getUserByID } = useB2BContext();
  const [rioDataList, setRioDataList] = useState<any>([]);
  const [ocaDataList, setOcaDataList] = useState<any>([]);
  const [wellnessDataList, setWellnessDataList] = useState<any>([]);


  const API_URL = process.env.REACT_APP_API_URL;
  const WELLNESS_API_URL = process.env.REACT_APP_WELLNESS_API;

  useSWR(API_URL + '/roi/all', fetcher, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    onSuccess(data) {
      setRioDataList(data);
    },
  });

  useSWR(API_URL + '/oca/all', fetcher, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    onSuccess(data) {
      setOcaDataList(data);
    },
  });

  useSWR(WELLNESS_API_URL + '/audit/getALL', fetcher, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    onSuccess(data) {
      setWellnessDataList(data);
    },
  });



  // const csvDataRio = rioDataList && rioDataList?.map((item: any) => ({
  //   id: item?._id,
  //   name: item?.first_Name,
  //   email: item?.corporate_Email,
  //   organization_Size: item?.organization_Size,
  //   preferred_Name: item?.preferred_Name,
  //   second_Name: item?.second_Name,
  //   createdAt: item?.createdAt
  // }));


  // const csvDataQuestionnaire = ocaDataList && ocaDataList?.map((item: any) => ({
  //   name: item?.first_Name,
  //   email: item?.corporate_Email,
  //   organization_Size: item?.organization_Size,
  //   preferred_Name: item?.preferred_Name,
  //   second_Name: item?.second_Name,
  //   status: item?.status,
  //   createdAt: item?.createdAt
  // }));


  const csvWellnessData = wellnessDataList && wellnessDataList?.map((item: any) => ({
    _id: item?._id,
    user: item?.user,
    "sportsLikeToWatch": item?.sport?.sportsLikeToWatch,
    "sportsLikeToPlay": item?.sport?.sportsLikeToPlay,
    "exercisePrefer": item?.sport?.exercisePrefer,
    "whichYouLike": item?.recreation?.whichYouLike,
    "howDoYouMoodToday": item?.mood?.howDoYouMoodToday,
    "howIsMoodThisWeek": item?.mood?.howIsMoodThisWeek,
    "lastTimeLaughtHeartedly": item?.mood?.lastTimeLaughtHeartedly,
    "whoMakesYouSmiles": item?.mood?.whoMakesYouSmiles,
    "responseForChallenge": item?.interaction?.responseForChallenge,
    "HowPrioritizeTasks": item?.interaction?.HowPrioritizeTasks,
    "othersDescribeYourCommiunication": item?.interaction?.othersDescribeYourCommiunication,
    "oftenRoleInGroupProjects": item?.interaction?.oftenRoleInGroupProjects,
    "approachForProblemSolving": item?.interaction?.approachForProblemSolving,
    "describeOfWorkEthic": item?.interaction?.describeOfWorkEthic,
    "InATeamSettingMoreImportantToYou": item?.interaction?.InATeamSettingMoreImportantToYou,
    "howHandleFeedback": item?.interaction?.howHandleFeedback,
    "motivesAtWork": item?.interaction?.motivesAtWork,
    "dealWithConflicts": item?.interaction?.dealWithConflicts,
    "resposeForPersonDidWrongToYou": item?.interaction?.resposeForPersonDidWrongToYou,
    "ageOrBirthYear": item?.destiny?.ageOrBirthYear,
    "bornDate": item?.destiny?.bornDate,
    "bornMonth": item?.destiny?.bornMonth,
    "howDoYouFeelToday": item?.colors?.howDoYouFeelToday,
    "PositiveAffirmation": item?.colors?.PositiveAffirmation,
    "mostFavorite": item?.colors?.mostFavorite,
    "NegativeAffirmation": item?.colors?.NegativeAffirmation,
    "leastFavorite": item?.colors?.leastFavorite,
    "colorRedWhoOutOfYourFamilyAndFriends": item?.associateColorRed?.colorRedWhoOutOfYourFamilyAndFriends,
    "whichArtsYouLike": item?.art?.whichArtsYouLike,
    "paintingLikeYouBests": item?.art?.paintingLikeYouBests,
    "shapeYouLikeBests": item?.art?.shapeYouLikeBests,
    "pickTopOne": item?.animals?.pickTopOne,
    "pickTopTwo": item?.animals?.pickTopTwo,
    createdAt: item?.createdAt
  }))

  return (
    <div className="contentBox export_csv_page">
      <div className="info">
        <Text className="title24">Export CSV</Text>
        <p className="export_tit">Knowledge Hub Data</p>
      </div>
      <div className="export_csv_grid">
        <div className="export_csv_card">
          <h3>ROI Responses</h3>
          <p>Knowledge Hub ROI questionnaire submissions</p>
          {rioDataList?.length > 0 ? (
            <CSVLink data={rioDataList} filename={"rio-data.csv"}>
              <Button className="button" icon={<DownloadOutlined />}>
                Export ROI Responses
              </Button>
            </CSVLink>
          ) : (
            <span className="export_csv_card__empty">No data available</span>
          )}
        </div>

        <div className="export_csv_card">
          <h3>Questionnaire Responses</h3>
          <p>Knowledge Hub OCA questionnaire submissions</p>
          {ocaDataList?.length > 0 ? (
            <CSVLink data={ocaDataList} filename={"questionnaire-data.csv"}>
              <Button className="button" icon={<DownloadOutlined />}>
                Export Questionnaire Responses
              </Button>
            </CSVLink>
          ) : (
            <span className="export_csv_card__empty">No data available</span>
          )}
        </div>

        <div className="export_csv_card">
          <h3>Personal Wellness Profile</h3>
          <p>Full wellness assessment responses</p>
          {csvWellnessData?.length > 0 ? (
            <CSVLink data={csvWellnessData} filename={"wellness-data.csv"}>
              <Button className="button" icon={<DownloadOutlined />}>
                Export All Responses
              </Button>
            </CSVLink>
          ) : (
            <span className="export_csv_card__empty">No data available</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default CSVDownload;
